import type {
  StaffColumnCreatePayload,
  StaffColumnDto,
  StaffColumnUpdatePayload,
  StaffMarkValue,
  StaffMarksMap,
} from "../types/staffColumn";
import {
  normalizeStaffColumn,
  normalizeStaffColumns,
  normalizeStaffMarks,
} from "../lib/forms/staffColumns";
import { apiRequest } from "./client";

function columnsPath(formId: number): string {
  return `/api/v1/forms/${formId}/staff-columns`;
}

function requireColumn(raw: unknown, message: string): StaffColumnDto {
  const column = normalizeStaffColumn(raw);
  if (!column) throw new Error(message);
  return column;
}

export function fetchStaffColumns(formId: number): Promise<StaffColumnDto[]> {
  return apiRequest<unknown>(columnsPath(formId)).then(normalizeStaffColumns);
}

export function createStaffColumn(
  formId: number,
  payload: StaffColumnCreatePayload,
): Promise<StaffColumnDto> {
  return apiRequest<unknown>(columnsPath(formId), {
    method: "POST",
    body: JSON.stringify(payload),
  }).then((body) => requireColumn(body, "Некорректный ответ создания колонки"));
}

export function updateStaffColumn(
  formId: number,
  columnId: number,
  payload: StaffColumnUpdatePayload,
): Promise<StaffColumnDto> {
  return apiRequest<unknown>(`${columnsPath(formId)}/${columnId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  }).then((body) =>
    requireColumn(body, "Некорректный ответ обновления колонки"),
  );
}

export function deleteStaffColumn(
  formId: number,
  columnId: number,
): Promise<void> {
  return apiRequest<void>(`${columnsPath(formId)}/${columnId}`, {
    method: "DELETE",
  });
}

export function patchSubmissionMarks(
  formId: number,
  submissionId: number,
  marks: Record<string, StaffMarkValue | null>,
): Promise<{ submissionId: number; marks: StaffMarksMap }> {
  return apiRequest<unknown>(
    `/api/v1/forms/${formId}/submissions/${submissionId}/marks`,
    {
      method: "PATCH",
      body: JSON.stringify({ marks }),
    },
  ).then((body) => {
    const record = body && typeof body === "object" ? (body as Record<string, unknown>) : {};
    const id = Number(record.submissionId ?? record.submission_id ?? submissionId);
    return {
      submissionId: Number.isFinite(id) ? Math.trunc(id) : submissionId,
      marks: normalizeStaffMarks(record.marks),
    };
  });
}
